var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 68,
    viewBox: "0 0 166 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_495_25018)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 142,
    height: 44,
    rx: 8,
    fill: "#00C13A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9987 37.332L33.832 33.1654L34.9987 31.957L37.1654 34.1237V27.332H38.832V34.1237L40.9987 31.957L42.1654 33.1654L37.9987 37.332ZM32.9987 40.6654C32.5404 40.6654 32.1481 40.5023 31.822 40.1762C31.4959 39.8501 31.3326 39.4576 31.332 38.9987V36.4987H32.9987V38.9987H42.9987V36.4987H44.6654V38.9987C44.6654 39.457 44.5023 39.8495 44.1762 40.1762C43.8501 40.5029 43.4576 40.6659 42.9987 40.6654H32.9987Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7031 37.4824V38.7266H52.4102V37.4824H57.2773V35.0762H53.6543V28.6777H55.1719V30.7012H60.9004V28.6777H62.418V35.0762H58.7812V37.4824H63.7031ZM55.1719 33.8457H60.9004V31.918H55.1719V33.8457ZM74.2496 28.9922V30.1816C74.2359 31.7129 74.2359 33.4355 73.7574 36.0195L72.2262 35.8555C72.7047 33.4492 72.7047 31.6924 72.7184 30.209H65.3355V28.9922H74.2496ZM75.4254 37.373V38.6172H64.1598V37.373H68.316V33.0801H69.8199V37.373H75.4254ZM80.4758 30.8242C80.4758 33.1211 81.5695 35.377 83.5383 36.2383L82.6223 37.4551C81.2209 36.7715 80.2365 35.459 79.7102 33.8457C79.1701 35.5479 78.1652 36.9629 76.7434 37.6875L75.7863 36.457C77.7961 35.5137 78.9172 33.1348 78.9309 30.8242V28.8555H80.4758V30.8242ZM86.2727 27.8574V40.2305H84.7687V33.0801H82.1711V31.8496H84.7687V27.8574H86.2727ZM100.311 27.8574V32.5469H102.211V33.791H100.311V40.2305H98.7934V27.8574H100.311ZM96.9203 29.0332V30.2637H92.6547V35.9375C94.5756 35.9375 96.0932 35.8418 97.7953 35.541L97.973 36.8262C96.059 37.1543 94.391 37.209 92.1625 37.209H91.1371V29.0332H96.9203ZM113.66 33.9688V35.1855H108.889V37.4551H107.344V35.1855H102.367V33.9688H113.66ZM112.416 38.7266V39.9707H103.748V36.3066H105.279V38.7266H112.416ZM108 28.1309C110.666 28.1309 112.43 29.1016 112.43 30.6602C112.43 32.2188 110.666 33.1758 108 33.1758C105.334 33.1758 103.57 32.2188 103.57 30.6602C103.57 29.1016 105.334 28.1309 108 28.1309ZM108 29.334C106.305 29.334 105.197 29.8125 105.211 30.6602C105.197 31.4805 106.305 31.959 108 31.959C109.709 31.959 110.803 31.4805 110.803 30.6602C110.803 29.8125 109.709 29.334 108 29.334ZM125.423 37.5234V38.7812H114.13V37.5234H118.998V35.5137H115.47V31.4668H122.58V29.9355H115.443V28.7051H124.084V32.6699H116.988V34.2695H124.371V35.5137H120.502V37.5234H125.423ZM135.915 33.6543V34.8711H127.247V28.9375H135.82V30.168H128.751V33.6543H135.915ZM137.173 37.3867V38.6445H125.88V37.3867H137.173Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_495_25018",
    x: 0,
    y: 0,
    width: 166,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_495_25018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_495_25018",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.05415df0c23db04cbf4ef12de9b9880b.svg";
export { ForwardRef as ReactComponent };